const BORDER_STYLE = {
  measured: "solid",
  reconciled: "solid",
  modelled: "dashed",
  estimated: "dotted",
  unobservable: "dotted",
};

export function BasisBadge({ basis = "modelled" }) {
  const style = BORDER_STYLE[basis] || "solid";
  return (
    <span
      className={`text-[9px] font-heading uppercase tracking-wide px-1.5 py-0.5 rounded-full border ${basis === "reconciled" ? "border-l-2" : ""} ${basis === "unobservable" ? "opacity-60" : ""}`}
      style={{ borderStyle: style, borderColor: "var(--oim-border)", color: "var(--oim-text-muted)" }}
      data-testid={`basis-badge-${basis}`}
    >
      {basis}
    </span>
  );
}
